'use client'

import { isNil } from 'lodash-es'
import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'

import { createNativeBridge } from './native'
import { Bridge, createBridge } from './web'

type BridgeContextState = {
  bridge: Bridge | null
}

export const BridgeContext = createContext<BridgeContextState | null>(null)

export const BridgeProvider = ({ children }: { children: ReactNode }) => {
  const [bridge, setBridge] = useState<Bridge | null>(null)

  useEffect(() => {
    createNativeBridge()
    const newBridge = createBridge()
    setBridge(newBridge)
  }, [])

  const value = useMemo(
    () => ({
      bridge,
    }),
    [bridge],
  )

  return (
    <BridgeContext.Provider value={value}>{children}</BridgeContext.Provider>
  )
}

export const useBridge = () => {
  const bridge = useContext(BridgeContext)

  if (isNil(bridge)) {
    throw new Error('Bridge is not initialized')
  }

  return bridge
}
